<template>
  <div>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-tabs  type="border-card" v-model="tabModel" @tab-click="reportTab">
      <el-tab-pane label="订单流水" name="orderFlow">
        <el-form :inline="true" :model="orderSearchForm" class="user-search" size="mini" a>
          <el-form-item label="">
            <el-select v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="selectedStation" placeholder="选择场站">
              <el-option
                v-for="item in stations"
                :key="item.id"
                :label="item.stationName"
                :value="item.stationCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="custType" placeholder="客户类型" @change="selectCustType">
              <el-option
                v-for="item in custTypes"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="orderSearchForm.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="orderSearchForm.beginTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="orderSearchForm.endTime" type="datetime"  value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchOrderReport">查询</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="orderData" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" label="运营商">
          </af-table-column>
          <af-table-column prop="stationCode" label="场站">
          </af-table-column>
          <af-table-column prop="pileCode" label="桩号">
          </af-table-column>
          <af-table-column prop="gunCode" label="枪号">
          </af-table-column>
          <af-table-column prop="dataFrom" label="订单来源">
          </af-table-column>
          <af-table-column prop="phone" label="手机号">
          </af-table-column>
          <af-table-column prop="chargeTotalElectricity" label="充电量(kW·h)">
          </af-table-column>
          <af-table-column prop="fee" label="费用(元)">
          </af-table-column>
          <af-table-column prop="electricityFee" label="电费(元)">
          </af-table-column>
          <af-table-column prop="serviceFee" label="服务费(元)">
          </af-table-column>
          <af-table-column prop="chargeBegTime" label="充电开始时间">
          </af-table-column>
          <af-table-column prop="chargeEndTime" label="充电结束时间">
          </af-table-column>
          <af-table-column prop="chargeType" label="充电方式">
          </af-table-column>
          <af-table-column prop="payType" label="支付方式">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getOrderReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="结算单" name="settlementOrder">
        <el-form :inline="true" :model="settlementSearchForm" class="user-search" size="mini">
          <el-form-item label="">
            <el-select v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.orderNo" placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="settlementSearchForm.settlementNo" placeholder="结算单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="settlementSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="开始时间">
            </el-date-picker>
            <el-date-picker v-model="settlementSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchSettlementReport">查询</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="settlementData" highlight-current-row border style="width: 100%;">
          <af-table-column prop="settlementNo" label="结算单号">
          </af-table-column>
          <af-table-column prop="operatorId" label="运营商" width="200">
          </af-table-column>
          <af-table-column prop="orderNo" label="订单号">
          </af-table-column>
          <af-table-column prop="phone" label="手机号">
          </af-table-column>
          <af-table-column prop="receAmt" label="应收金额(元)">
          </af-table-column>
          <af-table-column prop="actualAmt" label="实收金额(元)">
          </af-table-column>
          <af-table-column prop="noSettleAmt" label="未结清金额(元)">
          </af-table-column>
          <af-table-column prop="settType" label="结算类型">
          </af-table-column>
          <af-table-column prop="state" label="是否确认">
          </af-table-column>
          <af-table-column prop="createTime" label="创建时间">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getSettlementReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="场站报表" name="stationOrder">
        <el-form :inline="true" :model="stationSearchForm" class="user-search" size="mini">
          <el-select v-model="value" size="mini" placeholder="请选择" @change="selectLevel">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-form-item label="">
            <el-select v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="selectedStation" placeholder="选择场站">
              <el-option
                v-for="item in stations"
                :key="item.id"
                :label="item.stationName"
                :value="item.stationCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="开始时间"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束时间"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="开始时间"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="结束时间"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.beginTime"
                            type="year"
                            value-format="yyyy"
                            placeholder="开始时间"
                            v-if="showYear">
            </el-date-picker>
            <el-date-picker v-model="stationSearchForm.endTime"
                            type="year"
                            value-format="yyyy"
                            placeholder="结束时间"
                            v-if="showYear">
            </el-date-picker></el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchStationReport">查询</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="stationOrder" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" label="运营商">
          </af-table-column>
          <af-table-column prop="stationId" label="场站">
          </af-table-column>
          <af-table-column prop="day" label="日期" v-if="showDay">
          </af-table-column>
          <af-table-column prop="month" label="月份" v-if="showMonth">
          </af-table-column>
          <af-table-column prop="year" label="年份" v-if="showYear">
          </af-table-column>
          <af-table-column prop="totalElectricity" label="充电量(kW·h)">
          </af-table-column>
          <af-table-column prop="totalFee" label="充电收入(元)">
          </af-table-column>
          <af-table-column prop="totalElectricityFee" label="电费(元)">
          </af-table-column>
          <af-table-column prop="serviceFee" label="服务费(元)">
          </af-table-column>
          <af-table-column prop="orderNum" label="服务次数(次)">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getStationReport"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="运营商报表" name="operatorOrder">
        <el-form :inline="true" :model="operatorSearchForm" class="user-search" size="mini">
          <el-select v-model="value" size="mini" placeholder="请选择维度" @change="selectLevel">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-form-item label="">
            <el-select v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
              <el-option
                v-for="item in operators"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="开始时间"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束时间"
                            v-if="showDay">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="开始时间"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="结束时间"
                            v-if="showMonth">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.beginTime"
                            type="year"
                            value-format="yyyy"
                            placeholder="开始时间"
                            v-if="showYear">
            </el-date-picker>
            <el-date-picker v-model="operatorSearchForm.endTime"
                            type="year"
                            value-format="yyyy"
                            placeholder="结束时间"
                            v-if="showYear">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchOperatorReport">查询</el-button>
            <el-button type="primary" icon="el-icon-download" @click="exportData">Excel导出</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="operatorOrder" highlight-current-row border style="width: 100%;">
          <af-table-column prop="operatorId" label="运营商">
          </af-table-column>
          <af-table-column prop="day" label="日期" v-if="showDay">
          </af-table-column>
          <af-table-column prop="month" label="月份" v-if="showMonth">
          </af-table-column>
          <af-table-column prop="year" label="年份" v-if="showYear">
          </af-table-column>
          <af-table-column prop="totalElectricity" label="充电量(kW·h)">
          </af-table-column>
          <af-table-column prop="totalFee" label="充电收入(元)">
          </af-table-column>
          <af-table-column prop="totalElectricityFee" label="电费(元)">
          </af-table-column>
          <af-table-column prop="serviceFee" label="服务费(元)">
          </af-table-column>
          <af-table-column prop="orderNum" label="服务次数(次)">
          </af-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparam" @callFather="getOperatorReport"></Pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import api from '@/module/dataCenter/api/report.js'
  export default {
    components: {Pagination},
    name: 'reportManage',
    data() {
      return {
        tabModel:"orderFlow",
        operatorOrder:[],
        stationOrder:[],
        orderData: [],
        settlementData: [],
        // searchForm:{},
        orderSearchForm:{},
        settlementSearchForm:{},
        stationSearchForm:{},
        operatorSearchForm:{},
        options: [{
          value: '1',
          label: '每天订单'
        }, {
          value: '2',
          label: '每月订单'
        }, {
          value: '3',
          label: '每年订单'
        }],
        custTypes: [{
          value: '1',
          label: '个人'
        }, {
          value: '2',
          label: '集团'
        }],
        value: '1',//下拉选择框选中值
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        showDay: true,
        showMonth: false,
        showYear: false,
        tabPosition: 'order',//tab标签位置，流水（order）,站报表（stationOrder）,运营商报表(operatorOrder),
        operators: '',
        selectedOperator:'',
        stations: '',
        selectedStation: '',
        selectedCustType:'',
        payType : '',
        custType: ''
      }
    },
    methods: {
      //加载运营商列表
      loadOperators() {
        api.operatorList().then((res) => {
          this.operators = res.data
        })
      },
      selectOperator() {
        api.stationList([this.selectedOperator]).then((res)=>{
          this.stations = res.data
        })
      },
      selectCustType(val){
        switch(val){
          case '2' :{
            this.payType = 'credit'
            break;
          }
          case '1':{
            this.payType = 'other'
            break;
          }
        }
      },
      searchOrderReport(){
        this.getOrderReport()
      },
      searchOperatorReport(){
        this.getOperatorReport()
      },
      searchStationReport(){
        this.getStationReport()
      },
      searchSettlementReport(){
        this.getSettlementReport()
      },
      operatorDailyOrder(param){
        api.getOperatorDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorMonthlyOrder(param){
        api.getOperatorMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      operatorYearlyOrder(param){
        api.getOperatorYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.operatorOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationDailyOrder(param){
        api.getStationDailyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationMonthlyOrder(param){
        api.getStationMonthlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      stationYearlyOrder(param){
        api.getStationYearlyReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.stationOrder = res.data.list
          } else {
            this.$message.error(res.message);
          }
        })
      },
      async exportData(){
        //运营商报表导出
        if (this.tabPosition === 'operatorOrder') {
          switch(this.value) {
            case '1' : {
              api.downloadOperator(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,'运营商每天订单汇总')
                }
              })
              break;
            }
            case '2' : {
              api.downloadOperator2(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,'运营商每月订单汇总')
                }
              })
              break;
            }
            case '3' : {
              api.downloadOperator3(this.selectedOperator).then((res)=>{
                if (res){
                  this.downloadExcel(res,'运营商每年订单汇总')
                }
              })
              break;
            }
          }
        }
        //场站报表导出
        if (this.tabPosition === 'stationOrder') {
          switch(this.value) {
            case '1' : {
              api.downloadStation().then((res)=>{
                if (res){
                  this.downloadExcel(res,'场站每天订单汇总')
                }
              })
              break;
            }
            case '2' : {
              api.downloadStation2().then((res)=>{
                if (res){
                  this.downloadExcel(res,'场站每月订单汇总')
                }
              })
              break;
            }
            case '3' : {
              api.downloadStation3().then((res)=>{
                if (res){
                  this.downloadExcel(res,'场站每年订单汇总')
                }
              })
              break;
            }
          }
        }
        //订单报表
        if (this.tabPosition === 'order') {
          let param = {
            operatorId :this.selectedOperator,
            stationCode:this.selectedStation,
            payType: this.payType,
            chargeBegTime : this.orderSearchForm.beginTime===undefined?'':this.orderSearchForm.beginTime,
            chargeEndTime : this.orderSearchForm.endTime===undefined?'':this.orderSearchForm.beginTime
          }
          api.downloadOrder(param).then((res)=>{
            if (res){
              this.downloadExcel(res,'订单流水')
            }
          })
        }
        //结算单
        if (this.tabPosition === 'settlement') {
          let param = {
            operatorId :this.selectedOperator,
            beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
            endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
            settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
            orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
          }
          api.downSettlement(param).then((res)=>{
            if (res){
              this.downloadExcel(res,'结算单')
            }
          })
        }
      },
      reportTab(tab,event) {
        if (tab.label === '订单流水') {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.tabPosition = 'order'
          this.getOrderReport()
        }
        if (tab.label === '结算单') {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.tabPosition = 'settlement'
          this.getSettlementReport()
        }
        if (tab.label === '场站报表') {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.value = '1'
          this.tabPosition = 'stationOrder'
          this.getStationReport()
        }
        if (tab.label === '运营商报表') {
          this.selectedOperator = ''
          this.selectedStation = ''
          this.value = '1'
          this.tabPosition = 'operatorOrder'
          this.getOperatorReport()
        }
      },
      //依据选择的维度（日/月/年）获取表格数据
      selectLevel(){
        //位于运营商报表tab页
        if (this.tabPosition === 'operatorOrder') {
          this.operatorSearchForm.beginTime = ''
          this.operatorSearchForm.endTime = ''
          switch(this.value){
            case '1':{
              this.showDay = true
              this.showMonth = false
              this.showYear = false
              this.operatorDailyOrder()
              break;
            }
            case '2':{
              this.showDay = false
              this.showMonth = true
              this.showYear = false
              this.operatorMonthlyOrder()
              break;
            }
            case '3':{
              this.showDay = false
              this.showMonth = false
              this.showYear = true
              this.operatorYearlyOrder()
              break;
            }
          }
        }
        //位于站报表tab页
        if (this.tabPosition === 'stationOrder') {
          this.stationSearchForm.beginTime = ''
          this.stationSearchForm.endTime = ''
          switch(this.value){
            case '1':{
              this.showDay = true
              this.showMonth = false
              this.showYear = false
              this.stationDailyOrder()
              break;
            }
            case '2':{
              this.showDay = false
              this.showMonth = true
              this.showYear = false
              this.stationMonthlyOrder()
              break;
            }
            case '3':{
              this.showDay = false
              this.showMonth = false
              this.showYear = true
              this.stationYearlyOrder()
              break;
            }
          }
        }
      },
      getOperatorReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          beginTime: this.operatorSearchForm.beginTime===undefined?'':this.operatorSearchForm.beginTime,
          endTime: this.operatorSearchForm.endTime===undefined?'':this.operatorSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.operatorDailyOrder(param)
            break;
          }
          case '2':{
            this.operatorMonthlyOrder(param)
            break;
          }
          case '3':{
            this.operatorYearlyOrder(param)
            break;
          }
        }
      },
      getStationReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          stationCode: this.selectedStation,
          beginTime: this.stationSearchForm.beginTime===undefined?'':this.stationSearchForm.beginTime,
          endTime: this.stationSearchForm.endTime===undefined?'':this.stationSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        switch(this.value){
          case '1':{
            this.stationDailyOrder(param)
            break;
          }
          case '2':{
            this.stationMonthlyOrder(param)
            break;
          }
          case '3':{
            this.stationYearlyOrder(param)
            break;
          }
        }
      },
      orderReport(param){
        api.getOrderReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.orderData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getOrderReport(){
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          stationCode: this.selectedStation,
          payType:this.payType,
          beginTime: this.orderSearchForm.beginTime===undefined?'':this.orderSearchForm.beginTime,
          endTime: this.orderSearchForm.endTime===undefined?'':this.orderSearchForm.endTime
        }
        let param = Object.assign({}, this.pageparam)
        this.orderReport(param)
      },
      settlementReport(param){
        api.getSettlementReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.settlementData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getSettlementReport(){
        this.pageparam.t = {
          operatorId :this.selectedOperator,
          phone : this.settlementSearchForm.phone===undefined?'':this.settlementSearchForm.phone,
          beginTime : this.settlementSearchForm.beginTime===undefined?'':this.settlementSearchForm.beginTime,
          endTime : this.settlementSearchForm.endTime===undefined?'':this.settlementSearchForm.endTime,
          settlementNo : this.settlementSearchForm.settlementNo===undefined?'':this.settlementSearchForm.settlementNo,
          orderNo : this.settlementSearchForm.orderNo===undefined?'':this.settlementSearchForm.orderNo
        }

        let param = Object.assign({}, this.pageparam)
        this.settlementReport(param)
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      }
    },
    mounted(){
      this.loadOperators()
      this.getOrderReport()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/reportManage.vue